import produce from "immer";
import { EnumTiposLocal } from "../../../../utils/mxenumerados/tiposLocal";
// @ts-ignore
// @ts-ignore
import { store } from "../../../index";

export const TypesArmazemGeral = {
    ATUALIZAR_ETAPA: "armazemGeral/ATUALIZAR_ETAPA",
    ATUALIZAR_VOLUME_ORIGEM: "armazemGeral/ATUALIZAR_VOLUME_ORIGEM",
    ATUALIZAR_VOLUME_DESTINO: "armazemGeral/ATUALIZAR_VOLUME_DESTINO",
    ATUALIZAR_QUANTIDADE_REGULAR: "armazemGeral/ATUALIZAR_QUANTIDADE_REGULAR",
    ATUALIZAR_REMONTAGEM: "armazemGeral/ATUALIZAR_REMONTAGEM",
    RESETAR_REMONTAGEM: "armazemGeral/RESETAR_REMONTAGEM",
    LIMPA_DADOS_REMONTAGEM: "armazemGeral/LIMPA_DADOS_REMONTAGEM",
    ATUALIZAR_DADOS: "armazemGeral/ATUALIZAR_DADOS",
    ATUALIZAR_DOMINIOS: "armazemGeral/ATUALIZAR_DOMINIOS",
    ATUALIZAR_ITEM_LISTA_DE_MERCADORIA:
        "armazemGeral/ATUALIZAR_ITEM_LISTA_DE_MERCADORIA",
    ATUALIZAR_QUANTIDADE_OPERADORES:
        "armazemGeral/ATUALIZAR_QUANTIDADE_OPERADORES",
    ATUALIZAR_QUANTIDADE_AJUDANTES:
        "armazemGeral/ATUALIZAR_QUANTIDADE_AJUDANTES",
    ATUALIZAR_MATERIAL: "armazemGeral/ATUALIZAR_MATERIAL",
    ATUALIZAR_MATERIAL_QUANTIDADE: "armazemGeral/ATUALIZAR_MATERIAL_QUANTIDADE",
    ADICIONAR_MATERIAL: "armazemGeral/ADICIONAR_MATERIAL",
    REMOVER_MATERIAL: "armazemGeral/REMOVER_MATERIAL",
    ATUALIZAR_INICIO_OPERACAO: "armazemGeral/ATUALIZAR_INICIO_OPERACAO",
    ATUALIZAR_FIM_OPERACAO: "armazemGeral/ATUALIZAR_FIM_OPERACAO",
    ATUALIZAR_MATERIAL_OPERACIONAL:
        "armazemGeral/ATUALIZAR_MATERIAL_OPERACIONAL",
    ATUALIZAR_ITENS_LISTA_DE_MERCADORIA:
        "armazemGeral/ATUALIZAR_ITENS_LISTA_DE_MERCADORIA",
    ATUALIZAR_LOCAL_DE_REMOCAO: "armazemGeral/ATUALIZAR_LOCAL_DE_REMOCAO",
    ATUALIZAR_LOCAL_DE_POSICIONAMENTO:
        "armazemGeral/ATUALIZAR_LOCAL_DE_POSICIONAMENTO",
    ATUALIZAR_LOCAL_ID: "armazemGeral/ATUALIZAR_LOCAL_ID",
    RESETAR_POSICIONAMENTO: "armazemGeral/RESETAR_POSIONAMENTO",
    ATUALIZAR_SKILLS: "armazemGeral/ATUALIZAR_SKILLS",

    ATUALIZAR_MERCADORIA_ORIGEM_IMAGEM:
        "armazemGeral/ATUALIZAR_MERCADORIA_ORIGEM_IMAGEM"
};

/**@type {import("./useArmazemGeral").ArmazemGeral['state']} */
export const INITIAL = {
    etapa: 1,
    posicionamento: {
        localDeRemocao: "",
        localDePosicionamento: "",
        localId: ""
    },
    remontagem: {
        origem: {
            etiqueta: "",
            numeroFormatado: "",
            etiquetaFormatada: "",
            etiquetaResponse: "",
            nodeList: "",
            hasPermition: false,
            novaEtiqueta: false,
            id: "",
            embalagemRegular: "",
            embalagemMaster: "",
            tipo: "",
            tipoInicial: "",
            quantidadeRegular: "",
            contraMarca: "",
            comprimento: "",
            largura: "",
            altura: "",
            peso: "",
            localId: "",
            tipoLocal: EnumTiposLocal.Origem
        },
        destino: {
            etiqueta: "",
            id: "",
            embalagemRegular: "",
            embalagemMaster: "",
            tipo: "",
            tipoInicial: "",
            novaEtiqueta: false,
            quantidadeRegular: "",
            quantidadeRegularInicial: "",
            contraMarca: "",
            comprimento: "",
            largura: "",
            altura: "",
            peso: "",
            localId: "",
            tipoLocal: EnumTiposLocal.Destino
        },
        remontagemId: "",
        dataInicio: "",
        dataFim: "",
        ipaMarimex: "",
        emp: "",
        quadra: "",
        quadraNome: "",
        idRemontagemControle: "",
        operacao: "MAN",
        tempoOperacao: "",
        quantidadeOperadores: "",
        quantidadeAjudantes: "",
        mercadoriaOrigemImagem: [],
        mercadoriaDestinoImagem: [],
        origemAposRemontagemImagem: []
    },
    listaDeMercadoria: [],
    dominios: {
        EmbalagemMaster: [],
        EmbalagemRegular: [],
        Empilhadeira: [],
        Localidade: [],
        MaterialOperacional: [],
        TipoStatusVolume: []
    },
    materiais: [],
    inicioOperacao: "",
    fimOperacao: "",
    quantidadeAjudantes: "",
    quantidadeOperadores: "",
    skills: {
        ErrorMessage: "",
        Skills: [],
        ID: 0,
        Perfil: "",
        PodeDigitarEtiqueta: false,
        PodeScannear: false,
        Status: false
    }
};

export default function armazemGeralReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesArmazemGeral.ATUALIZAR_ETAPA:
            return {
                ...state,
                etapa: action.payload.etapa
            };
        case TypesArmazemGeral.ATUALIZAR_VOLUME_ORIGEM:
            return {
                ...state,
                remontagem: {
                    ...state.remontagem,
                    origem: Object.assign(
                        {},
                        state.remontagem.origem,
                        action.payload.volume
                    )
                }
            };
        case TypesArmazemGeral.ATUALIZAR_VOLUME_DESTINO:
            return {
                ...state,
                remontagem: {
                    ...state.remontagem,
                    destino: Object.assign(
                        {},
                        state.remontagem.destino,
                        action.payload.volume
                    )
                }
            };
        case TypesArmazemGeral.ATUALIZAR_QUANTIDADE_REGULAR:
            return {
                ...state,
                quantidadeRegular: action.payload.quantidadeRegular
            };
        case TypesArmazemGeral.ATUALIZAR_REMONTAGEM:
            return {
                ...state,
                remontagem: Object.assign(
                    {},
                    state.remontagem,
                    action.payload.remontagem
                )
            };
        case TypesArmazemGeral.RESETAR_REMONTAGEM:
            return Object.assign({}, INITIAL, {
                dominios: state.dominios,
                skills: state.skills,
                remontagem: Object.assign({}, INITIAL.remontagem, {
                    origem: { ...state.remontagem.origem }
                })
            });

        case TypesArmazemGeral.LIMPA_DADOS_REMONTAGEM:
            return Object.assign({}, INITIAL, {
                ...state.dominios
            });

        case TypesArmazemGeral.ATUALIZAR_DOMINIOS:
            return {
                ...state,
                dominios: action.payload.dominios
            };
        case TypesArmazemGeral.ATUALIZAR_DADOS:
            return {
                ...state,
                remontagem: {
                    ...state.remontagem,
                    [action.payload.tipo]: action.payload.valor
                }
            };
        case TypesArmazemGeral.ATUALIZAR_ITEM_LISTA_DE_MERCADORIA: {
            const novaLista = [...state.listaDeMercadoria];
            const index = state.listaDeMercadoria.findIndex(
                ({ id }) => id === action.payload.itemId
            );
            const saldoTotal =
                action.payload?.saldoTotal ?? novaLista[index].saldoTotal;
            novaLista[index][action.payload.campo] = action.payload.valorRemontado;
            novaLista[index].saldo = String(
                // arredondando para duas casas decimais
                Math.round(
                    (parseFloat(saldoTotal ?? "0") -
                        parseFloat(
                            isNaN(action.payload.valorRemontado) || !action.payload.valorRemontado
                                ? "0"
                                : action.payload.valorRemontado
                        )) *
                        10000
                ) / 10000
            );
            return {
                ...state,
                listaDeMercadoria: novaLista
            };
        }
        case TypesArmazemGeral.ATUALIZAR_ITENS_LISTA_DE_MERCADORIA: {
            return {
                ...state,
                listaDeMercadoria: action.payload.listaDeMercadoria
            };
        }
        case TypesArmazemGeral.ATUALIZAR_QUANTIDADE_OPERADORES:
            return {
                ...state,
                quantidadeOperadores: action.payload.quantidadeOperadores
            };
        case TypesArmazemGeral.ATUALIZAR_QUANTIDADE_AJUDANTES:
            return {
                ...state,
                quantidadeAjudantes: action.payload.quantidadeAjudantes
            };
        case TypesArmazemGeral.ATUALIZAR_MATERIAL: {
            return produce(state, draft => {
                draft.materiais[action.payload.index].material =
                    action.payload.material;
            });
        }
        case TypesArmazemGeral.ATUALIZAR_MATERIAL_QUANTIDADE: {
            return produce(state, draft => {
                draft.materiais[action.payload.index].quantidade =
                    action.payload.quantidade;
            });
        }
        case TypesArmazemGeral.ADICIONAR_MATERIAL: {
            return produce(state, draft => {
                draft.materiais.push({ material: "", quantidade: "" });
            });
        }
        case TypesArmazemGeral.REMOVER_MATERIAL: {
            return produce(state, draft => {
                draft.materiais.splice(action.payload.index, 1);
            });
        }
        case TypesArmazemGeral.ATUALIZAR_INICIO_OPERACAO:
            return {
                ...state,
                inicioOperacao: action.payload.inicioOperacao
            };
        case TypesArmazemGeral.ATUALIZAR_FIM_OPERACAO:
            return {
                ...state,
                fimOperacao: action.payload.fimOperacao
            };
        case TypesArmazemGeral.ATUALIZAR_MATERIAL_OPERACIONAL:
            return {
                ...state,
                materialOperacional: action.payload.material
            };
        case TypesArmazemGeral.ATUALIZAR_LOCAL_DE_REMOCAO:
            return {
                ...state,
                posicionamento: {
                    ...state.posicionamento,
                    localDeRemocao: action.payload.local
                }
            };
        case TypesArmazemGeral.ATUALIZAR_LOCAL_DE_POSICIONAMENTO:
            return {
                ...state,
                posicionamento: {
                    ...state.posicionamento,
                    localDePosicionamento: action.payload.local
                }
            };
        case TypesArmazemGeral.ATUALIZAR_LOCAL_ID:
            return {
                ...state,
                posicionamento: {
                    ...state.posicionamento,
                    localId: action.payload.localId
                }
            };
        case TypesArmazemGeral.RESETAR_POSICIONAMENTO:
            return {
                ...state,
                posicionamento: INITIAL.posicionamento
            };
        case TypesArmazemGeral.ATUALIZAR_SKILLS:
            return {
                ...state,
                skills: action.payload.skills
            };

        case TypesArmazemGeral.ATUALIZAR_MERCADORIA_ORIGEM_IMAGEM:
            return {
                ...state,
                mercadoriaOrigemImagem: action.payload.imagens
            };

        default:
            return state;
    }
}

function atualizarEtapa(etapa) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_ETAPA,
        payload: { etapa }
    };
}

function atualizarVolumeOrigem(volume) {
    if (typeof volume === "string") {
        volume = parseInt(volume || "0");
    }

    return {
        type: TypesArmazemGeral.ATUALIZAR_VOLUME_ORIGEM,
        payload: { volume }
    };
}

function atualizarVolumeDestino(volume) {
    if (typeof volume === "string") {
        volume = parseInt(volume || "0");
    }

    return {
        type: TypesArmazemGeral.ATUALIZAR_VOLUME_DESTINO,
        payload: { volume }
    };
}

function atualizarQuantidadeRegular(quantidadeRegular) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_QUANTIDADE_REGULAR,
        payload: { quantidadeRegular }
    };
}

function resetarRemontagem() {
    return {
        type: TypesArmazemGeral.RESETAR_REMONTAGEM
    };
}

function resetar() {
    return {
        type: TypesArmazemGeral.LIMPA_DADOS_REMONTAGEM
    };
}

function atualizarRemontagem(remontagem) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_REMONTAGEM,
        payload: { remontagem }
    };
}

function atualizarDados(tipo, dados) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_DADOS,
        payload: { valor: dados, tipo }
    };
}

function atualizarDominios(dominios) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_DOMINIOS,
        payload: { dominios }
    };
}

function atualizarRemontagemListaDeMercadoria(id, value) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_ITEM_LISTA_DE_MERCADORIA,
        payload: {
            itemId: id,
            valorRemontado: value,
            campo: "remontado"
        }
    };
}

function atualizarReconhecimentoListaDeMercadoria(id, value) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_ITEM_LISTA_DE_MERCADORIA,
        payload: { itemId: id, valorRemontado: value, campo: "reconhecido" }
    };
}

function atualizarMercadoriaOrigemImagem(imagens) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_MERCADORIA_ORIGEM_IMAGEM,
        payload: { imagens }
    };
}

function atualizarQuantidadeOperadores(quantidadeOperadores) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_QUANTIDADE_OPERADORES,
        payload: { quantidadeOperadores }
    };
}

function atualizarQuantidadeAjudantes(quantidadeAjudantes) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_QUANTIDADE_AJUDANTES,
        payload: { quantidadeAjudantes }
    };
}

function atualizarMaterial(index, material) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_MATERIAL,
        payload: { index, material }
    };
}

function atualizarMaterialQuantidade(index, quantidade) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_MATERIAL_QUANTIDADE,
        payload: { index, quantidade }
    };
}

function adicionarMaterial() {
    return {
        type: TypesArmazemGeral.ADICIONAR_MATERIAL
    };
}

function removerMaterial(index) {
    return {
        type: TypesArmazemGeral.REMOVER_MATERIAL,
        payload: { index }
    };
}

function atualizarInicioOperacao(inicioOperacao) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_INICIO_OPERACAO,
        payload: { inicioOperacao }
    };
}
function atualizarFimOperacao(fimOperacao) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_FIM_OPERACAO,
        payload: { fimOperacao }
    };
}
function resetarPosicionamento() {
    return {
        type: TypesArmazemGeral.RESETAR_POSICIONAMENTO
    };
}
function atualizarLocalDeRemocao(local) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_LOCAL_DE_REMOCAO,
        payload: { local }
    };
}
function atualizarLocalDePosicionamento(local) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_LOCAL_DE_POSICIONAMENTO,
        payload: { local }
    };
}
function atualizarLocalId(localId) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_LOCAL_ID,
        payload: { localId }
    };
}

function atualizarMaterialOperacional(material) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_MATERIAL_OPERACIONAL,
        payload: { material }
    };
}

function atualizarItensListaDeMercadoria(mercadoria) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_ITENS_LISTA_DE_MERCADORIA,
        payload: { listaDeMercadoria: mercadoria }
    };
}

function resetarListaMercadoria() {
    return {
        type: TypesArmazemGeral.ATUALIZAR_ITENS_LISTA_DE_MERCADORIA,
        payload: { listaDeMercadoria: INITIAL.listaDeMercadoria }
    };
}
function resetVolumeDestino() {
    return {
        type: TypesArmazemGeral.ATUALIZAR_VOLUME_DESTINO,
        payload: { volume: INITIAL.remontagem.destino }
    };
}

function atualizarSkills(skills) {
    return {
        type: TypesArmazemGeral.ATUALIZAR_SKILLS,
        payload: { skills }
    };
}

export const ArmazemGeralActions = {
    atualizarEtapa,
    atualizarVolumeOrigem,
    atualizarVolumeDestino,
    atualizarRemontagem,
    resetarRemontagem,
    resetar,
    atualizarDados,
    atualizarDominios,
    atualizarReconhecimentoListaDeMercadoria,
    atualizarRemontagemListaDeMercadoria: atualizarRemontagemListaDeMercadoria,
    atualizarItensListaDeMercadoria,
    atualizarMercadoriaOrigemImagem,
    resetVolumeDestino,
    atualizarQuantidadeRegular,
    atualizarQuantidadeOperadores,
    atualizarQuantidadeAjudantes,
    atualizarMaterial,
    atualizarMaterialQuantidade,
    adicionarMaterial,
    removerMaterial,
    atualizarInicioOperacao,
    atualizarFimOperacao,
    atualizarMaterialOperacional,
    resetarPosicionamento,
    atualizarLocalDeRemocao,
    atualizarLocalDePosicionamento,
    atualizarLocalId,
    resetarListaMercadoria,
    atualizarSkills
};
